import { ZyNodeViewWrapper } from '@/components/common/node-view-wrapper';
import type { ReactNodeViewProps } from '@tiptap/react';
import { NodeViewContent } from '@tiptap/react';
import { ITLAB_SECTION, ITLAB_SECTION_ATTR } from './zyitlab-shared';

export function ZyITLabInstructionsNodeView({ decorations }: ReactNodeViewProps) {
    return (
        <ZyNodeViewWrapper decorations={decorations}>
            <div {...{ [ITLAB_SECTION_ATTR]: ITLAB_SECTION.INSTRUCTIONS }}>
                <div
                    contentEditable={false}
                    className="mb-2 text-sm font-semibold text-gray-700"
                >
                    Introduction
                </div>
                <div className="mb-4 rounded border border-gray-300 bg-white p-3">
                    <NodeViewContent />
                </div>
            </div>
        </ZyNodeViewWrapper>
    );
}
